import { EventEmitter, Injectable } from '@angular/core';
import {
  AbstractControl,
  AsyncValidatorFn,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';
import { Observable, of, throwError } from 'rxjs';
import { catchError, distinctUntilChanged, map } from 'rxjs/operators';
import {
  HttpRequestPayload,
  IHttpErrorPayload,
  IHttpSuccessPayload,
} from '@core/models';
import { AccountDetails } from '@common/models';
import { AccountNameService } from '@common/services';
import { HttpProviderService } from '@core/service';
import { ACCOUNT_NUMBER_MINLENGTH } from '../../constants/base.constant';
import { CustomerService } from 'src/app/services/customer.service';

@Injectable()
export class AccountNumberValidationService {
  constructor(
    private accountService: AccountNameService,
    private httpProvider: HttpProviderService,
    public customerService: CustomerService
  ) {}

  getBeneKeyByType(paymentSystem) {
    switch (paymentSystem) {
      case 'INTBT':
        return 'beneAccount';
      case 'SWIFT':
        return 'beneSWIFT';
      case 'ACH':
        return 'beneACH';
    }
  }

  checkisAccountExsist(
    paymentSystem
  ): AsyncValidatorFn {
    return (control: AbstractControl): Observable<ValidationErrors | null> => {
      let beneKey = this.getBeneKeyByType(paymentSystem)
      if (
        control?.value &&
        control?.value != '' &&
        control?.value.length == ACCOUNT_NUMBER_MINLENGTH &&
        /^([a-z0-9]{5,})$/.test(control?.value)
      ) {let filter = '{"FilterExpression":"C1ANDC2", "FilterCriteria":[{"columnName":"'+beneKey+':accNo", "columnType":"String", "conditions":{"searchType":"equals", "searchText":"'+control?.value +'"} }, {"columnName":"status", "columnType":"String", "conditions":{"searchType":"equals", "searchText":"1"} } ] }';
        
        const request: HttpRequestPayload = {
          resource: '/beneficiary',
          method: 'GET',
          queryParams: [
            {
              key: 'criteriaDetails',
              value: filter,
            },
          ],
        };
        return this.httpProvider.invokeApi(request).pipe(
          map((response: IHttpSuccessPayload<any>) => {
            if (
              response && response.body && response?.body != null &&
              response?.body?.beneficiary &&
              response?.body?.beneficiary?.length > 0
            ) {
              let error: any = {};
              error['accountAlreadyExsist'] = true;
              return error;
            } else {
              const selectedAcc = this.customerService.getAccount('ALL').filter(x => {
                return x.accountNumber == control?.value
              })
              if(selectedAcc && selectedAcc.length > 0){
                let error: any = {};
                error['isMyAccountNumber'] = true;
                return error;
              }
              return null;
            }
          }),
          catchError((err: IHttpErrorPayload) => {
            return throwError(err);
          })
        );
      }
      else {
        return of(null)
      }
    };
  }

  accountNumberValidation(
    eventEmitter: EventEmitter<AccountDetails>
  ): AsyncValidatorFn {
    console.warn('account comp status async validator');
    return (
      control: AbstractControl
    ):
      | Promise<ValidationErrors | null>
      | Observable<ValidationErrors | null> => {
      return this.accountService.getAccountInfo(control.value).pipe(
        map((accountDetails: AccountDetails) => {
          eventEmitter.emit(accountDetails);
          return null;
        }),
        catchError((err: IHttpErrorPayload) => {
          let error: any = {};
          error[err.error.errorCode] = true;
          return of(error);
        })
      );
    };
  }
}
